import { Input, Label } from "@devhop/ui";
import { countLeaveDays } from "./leaveDays";

export type LeaveApproveAdjustValues = {
  startDate: string;
  endDate: string;
  days: number;
};

type LeaveApproveAdjustFieldsProps = {
  values: LeaveApproveAdjustValues;
  onChange: (values: LeaveApproveAdjustValues) => void;
  remainingDays?: number | null;
};

function toDateInput(iso: string): string {
  return iso.slice(0, 10);
}

export function LeaveApproveAdjustFields({
  values,
  onChange,
  remainingDays,
}: LeaveApproveAdjustFieldsProps) {
  const handleStartChange = (startDate: string) => {
    const endDate = values.endDate;
    const days = countLeaveDays(startDate, endDate);
    onChange({ startDate, endDate, days });
  };

  const handleEndChange = (endDate: string) => {
    const startDate = values.startDate;
    const days = countLeaveDays(startDate, endDate);
    onChange({ startDate, endDate, days });
  };

  const handleDaysChange = (raw: string) => {
    const parsed = Number.parseInt(raw, 10);
    if (!Number.isFinite(parsed) || parsed <= 0) return;
    onChange({ ...values, days: parsed });
  };

  const exceedsRemaining =
    remainingDays != null && values.days > 0 && values.days > remainingDays;

  return (
    <div className="space-y-4 py-2">
      <p className="text-muted-foreground text-sm">
        ສາມາດປັບວັນທີ ຫຼື ຈຳນວນວັນລາກ່ອນອະນຸມັດ (ປ່ອຍຄ່າເດີມຖ້າບໍ່ຕ້ອງການແກ້)
      </p>
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <Label htmlFor="approve-leave-start">ວັນເລີ່ມ</Label>
          <Input
            id="approve-leave-start"
            type="date"
            value={toDateInput(values.startDate)}
            onChange={(e) => handleStartChange(e.target.value)}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="approve-leave-end">ວັນສິ້ນສຸດ</Label>
          <Input
            id="approve-leave-end"
            type="date"
            value={toDateInput(values.endDate)}
            onChange={(e) => handleEndChange(e.target.value)}
          />
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="approve-leave-days">ຈຳນວນວັນລາ</Label>
        <Input
          id="approve-leave-days"
          type="number"
          min={1}
          step={1}
          value={values.days}
          onChange={(e) => handleDaysChange(e.target.value)}
          className="max-w-[8rem] tabular-nums"
        />
        {remainingDays != null ? (
          <p className="text-muted-foreground text-xs">
            ສິດຄົງເຫຼືອ: {remainingDays} ວັນ
          </p>
        ) : null}
        {exceedsRemaining ? (
          <p className="text-destructive text-xs">
            ຈຳນວນວັນລາເກີນສິດຄົງເຫຼືອ ({remainingDays} ວັນ)
          </p>
        ) : null}
      </div>
    </div>
  );
}

export function leaveApproveValuesFromRequest(request: {
  startDate: string;
  endDate: string;
  days: number;
}): LeaveApproveAdjustValues {
  return {
    startDate: request.startDate.slice(0, 10),
    endDate: request.endDate.slice(0, 10),
    days: request.days,
  };
}
